var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrokenArrowIcon = function SvgBrokenArrowIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D93E37",
    d: "M5.28 4.277c.339 0 .613.274.613.612 0 .338-.274.612-.612.612H3.087l2.806 2.804C7.079 7.23 8.12 6.243 9.019 5.345c.344-.344.801-.408 1.037-.172.236.236.207.657-.118.983-1.006 1.006-2.21 2.155-3.614 3.447-.114.115-.27.179-.431.179-.163 0-.318-.065-.433-.179L2.223 6.366v2.192c0 .338-.274.612-.611.612-.338 0-.612-.274-.612-.612V4.89c0-.338.274-.612.612-.612H5.28z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrokenArrowIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/broken-arrow-icon.82b7db4e2ad3b483acbc41159277ec39.svg";